/* =====================================================================
   STREAMINGPLAN · Engine
   ---------------------------------------------------------------------
   - Liest die Konfiguration aus window.STREAMINGPLAN_CONFIG
   - Holt die Live-Daten aus Google Sheets (über das Apps-Script Web-App
     JSON-Endpoint). Fällt automatisch auf die 4-Wochen-Rotation zurück,
     wenn keine URL gesetzt ist oder der Abruf fehlschlägt.
   - Baut einen echten Monatskalender (Mo–So), farbcodiert pro Streamer.
   - Klick auf einen Tag öffnet ein Detail-Panel mit Schichten + Opening
     (inkl. 1-Woche-Vorausplanung).
   ===================================================================== */
(function () {
  "use strict";

  /* ---------- Defaults (werden vom Liquid / der Preview überschrieben) ---------- */
  var DEFAULTS = {
    rootSelector: "#streamingplan",
    appsScriptUrl: "",        // Google Apps Script Web-App URL (/exec)
    rotationAnchor: "2026-06-01", // Montag der Woche, in der die Rotation mit "Typ A" startet
    earlyTime: "12:00",
    lateTime: "18:00",
    primeTime: "18:00",
    streamers: {
      Credo: { color: "#3f6fd6", initials: "Cr" },
      Crank: { color: "#2fa177", initials: "Ck" },
      Nouri: { color: "#7c4dff", initials: "No" }
    },
    earlyName: "Credo",
    lateName: "Crank",
    primeName: "Nouri",
    embeddedData: null,       // optionales Array für Offline/Preview
    entriesOnly: true         // NUR echte Einträge zeigen (keine generierte Credo/Crank-Rotation)
  };

  var MONTHS = ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
  var WEEKDAYS = ["Mo","Di","Mi","Do","Fr","Sa","So"];
  var WEEKDAYS_LONG = ["Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","Sonntag"];

  /* ---------- Date helpers (alle lokal, ohne Zeitzonen-Drift) ---------- */
  function ymd(d) {
    var m = String(d.getMonth() + 1).padStart(2, "0");
    var day = String(d.getDate()).padStart(2, "0");
    return d.getFullYear() + "-" + m + "-" + day;
  }
  function parseYmd(s) {
    var p = String(s).split("-");
    return new Date(+p[0], (+p[1] || 1) - 1, +p[2] || 1);
  }
  function isoDow(d) { return (d.getDay() + 6) % 7; } // Mo=0 … So=6
  function startOfWeek(d) {
    var c = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    c.setDate(c.getDate() - isoDow(c));
    return c;
  }
  function weeksBetween(a, b) {
    return Math.round((startOfWeek(b) - startOfWeek(a)) / (7 * 86400000));
  }
  function addDays(d, n) {
    var c = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    c.setDate(c.getDate() + n);
    return c;
  }

  /* =====================================================================
     ROTATIONS-LOGIK (4-Wochen-Plan aus der Vorlage)
     weekType "A" (Wochen 1 & 3):
        Credo = Früh 12:00 (frei Di) · Crank = Spät 18:00 (frei Do)
     weekType "B" (Wochen 2 & 4):
        Credo = Spät 18:00 (frei Do) · Crank = Früh 12:00 (frei Di)
     Sonntag immer: Nouri · Prime 18:00
     "frei": kein 12:00-Stream, der andere übernimmt 18:00
     ===================================================================== */
  function buildRotation(cfg) {
    var early = cfg.earlyName, late = cfg.lateName, prime = cfg.primeName;
    // Pro weekType + Wochentag (0=Mo … 6=So): { e: 12-Uhr-Person|null, l: 18-Uhr-Person, free: name|null }
    var A = {
      0: { e: early, l: late },                 // Mo
      1: { e: null,  l: late,  free: early },    // Di – Credo frei
      2: { e: early, l: late },                 // Mi
      3: { e: null,  l: early, free: late },     // Do – Crank frei → Credo 18:00
      4: { e: early, l: late },                 // Fr
      5: { e: early, l: late },                 // Sa
      6: { e: null,  l: prime, prime: true }     // So – Nouri Prime
    };
    var B = {
      0: { e: late,  l: early },
      1: { e: null,  l: early, free: late },     // Di – Crank frei
      2: { e: late,  l: early },
      3: { e: null,  l: late,  free: early },    // Do – Credo frei → Crank 18:00
      4: { e: late,  l: early },
      5: { e: late,  l: early },
      6: { e: null,  l: prime, prime: true }
    };
    return { A: A, B: B };
  }

  function weekTypeFor(date, anchor) {
    var diff = weeksBetween(anchor, date);
    return (((diff % 2) + 2) % 2) === 0 ? "A" : "B";
  }

  /* Liefert die Basis-Schichten eines Tages aus der Rotation. */
  function baseDay(date, cfg, rot) {
    var dow = isoDow(date);
    var type = weekTypeFor(date, parseYmd(cfg.rotationAnchor));
    var def = rot[type][dow];
    var slots = [];

    if (def.prime) {
      slots.push({ shift: "Prime", time: cfg.primeTime, person: def.l, status: "prime" });
      return { slots: slots, weekType: type };
    }
    // 12:00 Slot
    if (def.e) {
      slots.push({ shift: "Früh", time: cfg.earlyTime, person: def.e, status: "live" });
    } else {
      slots.push({ shift: "Früh", time: cfg.earlyTime, person: def.free, status: "free" });
    }
    // 18:00 Slot
    slots.push({ shift: "Spät", time: cfg.lateTime, person: def.l, status: "live" });
    return { slots: slots, weekType: type };
  }

  /* =====================================================================
     SHEET-DATEN MERGEN
     Sheet-Einträge (date+shift) überschreiben die Rotation und liefern
     Opening / Notiz. So muss man im Sheet i.d.R. nur Openings pflegen.
     ===================================================================== */
  function indexEntries(entries) {
    var map = {};
    (entries || []).forEach(function (e) {
      if (!e || !e.date) return;
      var key = e.date + "|" + (e.shift || "").toLowerCase();
      map[key] = e;
    });
    return map;
  }

  function mergeDay(date, cfg, rot, entryMap) {
    // NUR-ECHTE-EINTRÄGE-MODUS: keine generierte Rotation, nur was wirklich geplant ist
    if (cfg.entriesOnly) {
      var dk = ymd(date);
      var sl = [];
      Object.keys(entryMap || {}).forEach(function (k) {
        if (k.indexOf(dk + "|") !== 0) return;
        var e = entryMap[k];
        var sh = e.shift || "Spät";
        var t = e.time || (/^prime/i.test(sh) ? cfg.primeTime : /^fr/i.test(sh) ? cfg.earlyTime : cfg.lateTime);
        sl.push({
          shift: sh, time: t, person: e.person || "",
          status: e.status ? String(e.status).toLowerCase() : "live",
          opening: e.opening, sr: e.sr, info: e.info, note: e.note,
          account: e.account, login: e.login, password: e.password, balance: e.balance, accounts: e.accounts
        });
      });
      sl.sort(function (a, b) { return String(a.time).localeCompare(String(b.time)); });
      return { slots: sl, weekType: weekTypeFor(date, parseYmd(cfg.rotationAnchor)) };
    }
    var base = baseDay(date, cfg, rot);
    var dkey = ymd(date);
    base.slots = base.slots.map(function (slot) {
      var key = dkey + "|" + slot.shift.toLowerCase();
      var e = entryMap[key];
      if (e) {
        if (e.person) slot.person = e.person;
        if (e.time) slot.time = e.time;
        if (e.status) slot.status = String(e.status).toLowerCase();
        if (e.opening) slot.opening = e.opening;   // €-Betrag / Opening-Ziel
        if (e.sr) slot.sr = e.sr;                   // €-Betrag / SR (Subraid/Sub-Rekord)
        if (e.info) slot.info = e.info;             // Beschreibungstext
        if (e.note) slot.note = e.note;
        if (e.account)  slot.account  = e.account;  // Casino/Konto (z.B. Golisimo)
        if (e.login)    slot.login    = e.login;    // Login / E-Mail
        if (e.password) slot.password = e.password; // Passwort
        if (e.balance)  slot.balance  = e.balance;  // aktuelle Balance
        if (e.accounts) slot.accounts = e.accounts; // alle Spielkonten (Opening/SR/Reserve)
      }
      return slot;
    });
    return base;
  }

  /* =====================================================================
     WIDGET
     ===================================================================== */
  function StreamingPlan(cfg) {
    this.cfg = cfg;
    this.rot = buildRotation(cfg);
    this.root = document.querySelector(cfg.rootSelector);
    this.entryMap = {};
    this.updated = null;
    this.today = new Date();
    this.view = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
    if (!this.root) { console.warn("[Streamingplan] root nicht gefunden:", cfg.rootSelector); return; }
    this.applyColors();
    this.scaffold();
    this.load();
  }

  StreamingPlan.prototype.applyColors = function () {
    var s = this.cfg.streamers || {};
    var rootEl = this.root.closest(".sp-root") || this.root;
    if (s[this.cfg.earlyName]) rootEl.style.setProperty("--sp-credo", s[this.cfg.earlyName].color);
    Object.keys(s).forEach(function (name) {
      // generische Variable pro Streamer (kebab)
      var key = "--sp-color-" + name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
      rootEl.style.setProperty(key, s[name].color);
    });
    if (s[this.cfg.primeName]) rootEl.style.setProperty("--sp-nouri", s[this.cfg.primeName].color);
  };

  StreamingPlan.prototype.colorOf = function (name) {
    var s = this.cfg.streamers || {};
    return (s[name] && s[name].color) || "var(--sp-free)";
  };
  StreamingPlan.prototype.initialsOf = function (name) {
    var s = this.cfg.streamers || {};
    if (s[name] && s[name].initials) return s[name].initials;
    return (name || "?").slice(0, 2);
  };

  StreamingPlan.prototype.scaffold = function () {
    var c = this.cfg;
    this.root.innerHTML =
      '<div class="sp-shell">' +
        '<div class="sp-header">' +
          '<div class="sp-title-wrap">' +
            '<span class="sp-eyebrow"><span class="sp-live-dot"></span>' + esc(c.eyebrow || "Live-Streamingplan") + '</span>' +
            '<h2 class="sp-title">' + esc(c.title || "Streaming-Plan") + '</h2>' +
            '<p class="sp-subtitle">' + esc(c.subtitle || "") + '</p>' +
          '</div>' +
          '<div class="sp-nav">' +
            '<button type="button" data-nav="-1" aria-label="Vorheriger Monat">‹</button>' +
            '<span class="sp-month-label"></span>' +
            '<button type="button" data-nav="1" aria-label="Nächster Monat">›</button>' +
          '</div>' +
        '</div>' +
        '<div class="sp-toolbar">' +
          '<div class="sp-legend"></div>' +
          '<div class="sp-updated"></div>' +
        '</div>' +
        '<div class="sp-cal">' +
          '<div class="sp-weekdays"></div>' +
          '<div class="sp-grid"></div>' +
        '</div>' +
        '<div class="sp-status" hidden></div>' +
      '</div>' +
      '<div class="sp-modal-backdrop" role="dialog" aria-modal="true">' +
        '<div class="sp-modal">' +
          '<div class="sp-modal-head">' +
            '<div><div class="sp-modal-date"></div><h3 class="sp-modal-title"></h3><div class="sp-modal-hint"></div></div>' +
            '<button type="button" class="sp-close" aria-label="Schließen">✕</button>' +
          '</div>' +
          '<div class="sp-modal-body"></div>' +
        '</div>' +
      '</div>';

    // Wochentage
    var wd = this.root.querySelector(".sp-weekdays");
    wd.innerHTML = WEEKDAYS.map(function (d) { return '<div class="sp-weekday">' + d + '</div>'; }).join("");

    // Legende
    var legendEl = this.root.querySelector(".sp-legend");
    legendEl.innerHTML = this.legendHtml();

    // Events
    var self = this;
    // Streamer in der Legende anklicken -> nur seine Streams (nochmal = alle)
    legendEl.addEventListener("click", function (e) {
      var btn = e.target.closest(".sp-legend-btn");
      if (!btn) return;
      var name = btn.dataset.person;
      self.filterPerson = (self.filterPerson === name) ? null : name;
      legendEl.innerHTML = self.legendHtml();
      self.render();
    });
    this.root.querySelectorAll("[data-nav]").forEach(function (b) {
      b.addEventListener("click", function () {
        self.view.setMonth(self.view.getMonth() + (+b.dataset.nav));
        self.render();
      });
    });
    var backdrop = this.root.querySelector(".sp-modal-backdrop");
    this.root.querySelector(".sp-close").addEventListener("click", function () { self.closeModal(); });
    backdrop.addEventListener("click", function (e) { if (e.target === backdrop) self.closeModal(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") self.closeModal(); });
  };

  StreamingPlan.prototype.legendHtml = function () {
    var s = this.cfg.streamers || {};
    var fp = this.filterPerson;
    var html = Object.keys(s).map(function (name) {
      return '<button type="button" class="sp-legend-item sp-legend-btn' + (fp === name ? ' is-active' : '') +
        '" data-person="' + esc(name) + '"><span class="sp-swatch" style="background:' + esc(s[name].color) + '"></span>' + esc(name) + '</button>';
    }).join("");
    html += '<span class="sp-legend-item is-free"><span class="sp-swatch"></span>frei (kein 12:00)</span>';
    return html;
  };

  StreamingPlan.prototype.load = function () {
    var self = this, c = this.cfg;
    // Eingebettete Daten (Preview / Offline)
    if (Array.isArray(c.embeddedData)) {
      this.entryMap = indexEntries(c.embeddedData);
      this.updated = c.embeddedUpdated || null;
      this.render();
      return;
    }
    if (!c.appsScriptUrl) { this.render(); return; }

    this.setStatus("Lade Live-Daten aus Google Sheets …");
    fetch(c.appsScriptUrl, { method: "GET" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) {
        if (data.rotationAnchor) c.rotationAnchor = data.rotationAnchor;
        if (data.streamers) { c.streamers = Object.assign({}, c.streamers, data.streamers); self.applyColors(); }
        self.entryMap = indexEntries(data.entries || data.rows || []);
        self.updated = data.updated || null;
        self.setStatus("");
        self.render();
      })
      .catch(function (err) {
        console.warn("[Streamingplan] Sheet-Abruf fehlgeschlagen, nutze Rotation.", err);
        self.setStatus("Live-Daten nicht erreichbar – zeige geplante Rotation.", true);
        self.render();
      });
  };

  StreamingPlan.prototype.setStatus = function (msg, isError) {
    var el = this.root.querySelector(".sp-status");
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ""; return; }
    el.hidden = false;
    el.textContent = msg;
    el.classList.toggle("is-error", !!isError);
  };

  StreamingPlan.prototype.render = function () {
    var self = this, c = this.cfg;
    var year = this.view.getFullYear(), month = this.view.getMonth();
    this.root.querySelector(".sp-month-label").textContent = MONTHS[month] + " " + year;

    var first = new Date(year, month, 1);
    var gridStart = startOfWeek(first);
    var grid = this.root.querySelector(".sp-grid");
    var html = "";
    var todayKey = ymd(this.today);

    for (var i = 0; i < 42; i++) {
      var d = addDays(gridStart, i);
      var inMonth = d.getMonth() === month;
      var key = ymd(d);
      var day = mergeDay(d, c, this.rot, this.entryMap);
      var isSun = isoDow(d) === 6;

      // Streamer-Filter: nur Slots der gewählten Person
      var daySlots = day.slots;
      if (this.filterPerson) {
        daySlots = day.slots.filter(function (s) { return s.person === self.filterPerson; });
      }

      var cls = "sp-cell";
      if (!inMonth) cls += " is-outside";
      if (key === todayKey) cls += " is-today";
      if (isSun) cls += " is-sunday";
      if (inMonth && key < todayKey) cls += " is-past";          // für "heute vorne" (Handy)
      if (this.filterPerson && !daySlots.length) cls += " is-filtered-out";

      var hasOpening = daySlots.some(function (s) { return s.opening; });
      var slotsHtml = daySlots.map(function (s) { return self.slotChip(s); }).join("");

      html += '<div class="' + cls + '" data-date="' + key + '" tabindex="0">' +
                '<div class="sp-cell-head">' +
                  '<span class="sp-cell-weekday">' + WEEKDAYS[isoDow(d)] + '</span>' +
                  '<span class="sp-daynum">' + d.getDate() + '</span>' +
                  (key === todayKey ? '<span class="sp-today-badge">Heute</span>' : '') +
                '</div>' +
                (hasOpening ? '<span class="sp-opening-flag" title="Opening geplant"></span>' : '') +
                '<div class="sp-slots">' + slotsHtml + '</div>' +
              '</div>';
    }
    grid.innerHTML = html;

    // Updated label
    var up = this.root.querySelector(".sp-updated");
    up.innerHTML = this.updated
      ? 'Aktualisiert: <b>' + esc(formatDateTime(this.updated)) + '</b>'
      : 'Quelle: <b>geplante Rotation</b>';

    // Klick-Events
    grid.querySelectorAll(".sp-cell").forEach(function (cell) {
      function open() { self.openModal(cell.dataset.date); }
      cell.addEventListener("click", open);
      cell.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); } });
    });
  };

  StreamingPlan.prototype.slotChip = function (s) {
    if (s.status === "free") {
      return '<div class="sp-slot is-free"><span class="sp-time">' + esc(s.time) + '</span>' +
             '<span class="sp-name">frei' + (s.person ? ' – ' + esc(s.person) : '') + '</span></div>';
    }
    if (s.status === "prime") {
      return '<div class="sp-slot is-prime" style="--slot-color:' + this.colorOf(s.person) + '">' +
             '<span class="sp-time">' + esc(s.time) + '</span>' +
             '<span class="sp-name">' + esc(s.person) + '</span></div>';
    }
    return '<div class="sp-slot" style="--slot-color:' + this.colorOf(s.person) + '">' +
           '<span class="sp-time">' + esc(s.time) + '</span>' +
           '<span class="sp-name">' + esc(s.person) + '</span></div>';
  };

  /* ---------- Modal ---------- */
  StreamingPlan.prototype.openModal = function (dateKey) {
    var self = this, c = this.cfg;
    var date = parseYmd(dateKey);
    var day = mergeDay(date, c, this.rot, this.entryMap);
    var backdrop = this.root.querySelector(".sp-modal-backdrop");
    var dow = isoDow(date);

    this.root.querySelector(".sp-modal-date").textContent =
      WEEKDAYS_LONG[dow] + " · " + date.getDate() + ". " + MONTHS[date.getMonth()] + " " + date.getFullYear();
    this.root.querySelector(".sp-modal-title").textContent =
      (dow === 6 ? "Prime-Sonntag" : "Tagesplan");

    this.root.querySelector(".sp-modal-hint").textContent =
      "Tipp: auf einen Namen tippen für Opening & SR";

    var body = this.root.querySelector(".sp-modal-body");
    var rows = day.slots.map(function (s, i) { return self.personRow(s, i); }).join("");

    // 1-Woche-Vorausplanung: Opening des nächsten Sonntags (Prime)
    var preview = "";
    if (dow === 6) {
      var nextSun = addDays(date, 7);
      var nextDay = mergeDay(nextSun, c, this.rot, this.entryMap);
      var nextPrime = nextDay.slots.find(function (s) { return s.status === "prime"; });
      if (nextPrime) {
        preview = '<div class="sp-preview-next">🔮 <b>Vorschau nächste Woche</b> · ' +
          nextSun.getDate() + ". " + MONTHS[nextSun.getMonth()] + ": " +
          esc(nextPrime.person) + " · " + esc(nextPrime.time) +
          (nextPrime.opening ? ' — <i>Opening ' + esc(nextPrime.opening) + '</i>' : ' — Opening folgt') +
          '</div>';
      }
    }

    body.innerHTML = rows + preview;
    backdrop.classList.add("is-open");

    // Namen anklickbar → Detail (Opening / SR) auf-/zuklappen
    body.querySelectorAll(".sp-person-row").forEach(function (row) {
      row.addEventListener("click", function () {
        var item = row.parentNode;
        var wasOpen = item.classList.contains("is-open");
        body.querySelectorAll(".sp-person-item").forEach(function (it) { it.classList.remove("is-open"); });
        if (!wasOpen) item.classList.add("is-open");
      });
    });
    // Erstes Stream-Detail direkt offen zeigen
    var firstLive = body.querySelector(".sp-person-item:not(.is-free)");
    if (firstLive) firstLive.classList.add("is-open");

    // Passwort anzeigen/verbergen
    body.querySelectorAll(".sp-pw-toggle").forEach(function (btn) {
      btn.addEventListener("click", function (ev) {
        ev.stopPropagation();
        var el = body.querySelector("#" + btn.dataset.target);
        if (!el) return;
        var shown = el.dataset.shown === "1";
        el.dataset.shown = shown ? "0" : "1";
        el.textContent = shown ? "••••••••" : (el.dataset.pw || "");
        btn.textContent = shown ? "anzeigen" : "verbergen";
      });
    });
    // Login per Klick kopieren
    body.querySelectorAll(".sp-copy").forEach(function (el) {
      el.addEventListener("click", function (ev) {
        ev.stopPropagation();
        try { navigator.clipboard.writeText(el.dataset.copy || el.textContent || ""); } catch (e) {}
      });
    });
  };

  // Ein klickbarer Namen-Eintrag + aufklappbares Detail
  StreamingPlan.prototype.personRow = function (s, index) {
    var isFree = s.status === "free";
    var color = isFree ? "var(--sp-free)" : this.colorOf(s.person);
    var shiftLabel = s.status === "prime" ? "Prime-Stream" : (isFree ? "frei" : s.shift + "schicht");
    var name = isFree ? ("Kein " + esc(s.time) + "-Stream") : esc(s.person);
    var avatar = isFree ? "—" : esc(this.initialsOf(s.person));

    var row = '<button type="button" class="sp-person-row" style="--slot-color:' + color + '">' +
        '<span class="sp-avatar" style="--slot-color:' + color + '">' + avatar + '</span>' +
        '<span class="sp-person-meta"><span class="sp-stream-name">' + name + '</span>' +
        '<span class="sp-stream-shift">' + esc(shiftLabel) + (isFree && s.person ? ' · ' + esc(s.person) : '') + '</span></span>' +
        '<span class="sp-stream-time">' + esc(s.time) + ' Uhr</span>' +
        '<span class="sp-chev" aria-hidden="true">⌄</span>' +
      '</button>';

    var detail = '<div class="sp-person-detail">' + this.detailHtml(s, isFree) + '</div>';
    return '<div class="sp-person-item' + (isFree ? ' is-free' : '') + '">' + row + detail + '</div>';
  };

  // Inhalt des aufgeklappten Details: "Credo Live um 18 Uhr" + 20.000€ Opening / 10.000€ SR
  StreamingPlan.prototype.detailHtml = function (s, isFree) {
    if (isFree) {
      return '<p class="sp-detail-line">' + esc(s.person || "Streamer") + ' hat heute frei – kein ' +
        esc(s.time) + '-Stream. Der andere übernimmt die 18:00-Schicht.</p>' +
        (s.note ? '<div class="sp-note">' + esc(s.note) + '</div>' : '');
    }
    var verb = s.status === "prime" ? "Prime-Stream" : "live";
    var html = '<p class="sp-detail-line"><b>' + esc(s.person) + '</b> ' + verb +
      ' um <b>' + esc(s.time) + ' Uhr</b></p>';

    if (s.opening || s.sr) {
      html += '<div class="sp-stats">';
      if (s.opening) {
        html += '<div class="sp-stat is-opening"><span class="sp-stat-lbl">★ Opening</span>' +
                '<span class="sp-stat-val">' + esc(s.opening) + '</span></div>';
      }
      if (s.sr) {
        html += '<div class="sp-stat is-sr" title="Subraid"><span class="sp-stat-lbl">⚡ SR · Subraid</span>' +
                '<span class="sp-stat-val">' + esc(s.sr) + '</span></div>';
      }
      html += '</div>';
    }
    // Spielkonten dieses Streams (Opening / SR / Reserve) – jeweils mit Login/Passwort
    var accounts = (s.accounts && s.accounts.length)
      ? s.accounts
      : ((s.account || s.login || s.password) ? [{ label: "", casino: s.account, login: s.login, password: s.password, amount: s.balance }] : []);

    accounts.forEach(function (acc) {
      if (!acc.casino && !acc.login && !acc.password) return;
      html += '<div class="sp-account">' +
        '<div class="sp-account-head">🎰 Spielkonto' + (acc.label ? ' · ' + esc(acc.label) : '') + '</div>' +
        '<div class="sp-account-grid">';
      if (acc.casino) html += '<div class="sp-account-row"><span>Casino</span><b>' + esc(acc.casino) + '</b></div>';
      if (acc.amount) html += '<div class="sp-account-row"><span>Betrag</span><b class="sp-balance">' + esc(acc.amount) + '</b></div>';
      if (acc.login)  html += '<div class="sp-account-row"><span>Login</span><b class="sp-copy" data-copy="' + esc(acc.login) + '">' + esc(acc.login) + '</b></div>';
      if (acc.password) {
        var pid = 'sp-pw-' + Math.random().toString(36).slice(2, 8);
        html += '<div class="sp-account-row"><span>Passwort</span>' +
          '<b class="sp-pw" id="' + pid + '" data-pw="' + esc(acc.password) + '" data-shown="0">••••••••</b>' +
          '<button type="button" class="sp-pw-toggle" data-target="' + pid + '">anzeigen</button></div>';
      }
      html += '</div></div>';
    });

    if (s.info) html += '<div class="sp-opening-text sp-detail-info">' + esc(s.info) + '</div>';
    if (s.note) html += '<div class="sp-note">' + esc(s.note) + '</div>';
    if (!s.opening && !s.sr && !s.info && !s.note && !accounts.length) {
      html += '<div class="sp-note">Noch kein Opening / SR / Konto hinterlegt.</div>';
    }
    return html;
  };

  StreamingPlan.prototype.closeModal = function () {
    var b = this.root.querySelector(".sp-modal-backdrop");
    if (b) b.classList.remove("is-open");
  };

  /* ---------- Utils ---------- */
  function esc(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function formatDateTime(s) {
    var d = new Date(s);
    if (isNaN(d)) return s;
    return d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  }

  /* ---------- Auto-Init ---------- */
  function init() {
    var cfg = Object.assign({}, DEFAULTS, window.STREAMINGPLAN_CONFIG || {});
    if (window.STREAMINGPLAN_CONFIG && window.STREAMINGPLAN_CONFIG.streamers) {
      cfg.streamers = Object.assign({}, DEFAULTS.streamers, window.STREAMINGPLAN_CONFIG.streamers);
    }
    window.__streamingplan = new StreamingPlan(cfg);
    window.__amkStreamingplan = window.__streamingplan; // für AMK-App (Reload beim View-Öffnen)
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.StreamingPlan = StreamingPlan;
})();